export var getStatusTranslation = function (intl, key) {
    if (!key)
        return "";
    return intl.formatMessage({ id: "ui-br-agency.status.".concat(key) });
};
